<template>
  <div :class="$style.presentationDialog">
    <div class="d-flex align-items-center">
      <div class="pr-3">
        <img src="@/assets/img/trail/goal.png" class="img-fluid" style="max-width: 60px" />
      </div>

      <div style="flex: 1">
        <div :class="$style.presentationDialog__header" class="mb-3">
          Trilha do sucesso
        </div>

        <div :class="$style.presentationDialog__description" class="mb-4">
          Descubra as habilidades digitais que mais se adequam ao seu perfil e acompanhe o progresso rumo aos seus objetivos!
        </div>

        <div class="text-center d-flex flex-column align-items-center">
          <router-link
            :to="{ name: 'trail.pick' }"
            class="mb-2"
            :class="$style.presentationDialog__button"
            @click.native="pick"
          >
            Escolher minha trilha
          </router-link>

          <button
            type="submit"
            :class="$style.presentationDialog__button2"
            @click="dismiss"
          >escolher depois</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits('close')

function dismiss () {
  const timestamp = Math.round((new Date).getTime() / 1000)
  localStorage.setItem('trailDialogDismissTime', timestamp)
  emit('close')
}

function pick () {
  emit('close')
}
</script>

<style lang="scss" scoped module>
.presentationDialog {
  padding: 1.5rem;
  border-top: 4px solid #f80;

  &__header {
    font-family: 'Poppins';
    font-weight: 700;
    text-align: center;
    font-size: 1.25rem;
  }

  &__description {
    text-align: center;
    font-size: 1.0625rem;
  }

  &__button {
    background: linear-gradient(27.53deg,#f80 5%, #6913fe 100%);
    padding: 10px 24px;
    border-radius: 30px;
    color: #fff;
    font-family: Poppins;
    font-weight: 600;
  }

  &__button2 {
    color: lighten(#000, 40);
    padding: 8px 0;
  }
}
</style>